import React, { SVGAttributes } from "react";

export const LogoCOESBA: React.FC<Omit<SVGAttributes<any>, 'dangerouslySetInnerHTML'>> = ( { ...props } ) => {
  return (
    <img
      {...props}
      src="/assets/logos_COESBA.png" alt="Coesba" />
  );
};